module.exports = __webpack_public_path__ + "img/1622983219.3386b869.png";